export default {
    common: {
        home: 'Home',
        mainMenu: 'Main menu',
        inbox: 'My inbox',
        requests: 'My Profile',
        reports: 'Reports',
        settings: 'Settings',
        accesses: 'Accesses',
        flowAdmin: 'Flow Admin',
        states: 'States',
        documents: 'Documents',
        reviewers: 'Reviewers',
        close: 'Close',
        save: 'Save',
        edit: 'Edit',
        delete: 'Delete',
        detail: 'Detail',
        actions: 'Actions',
        status: 'Status',
        value: 'Value',
        area: 'Area',
        creatorUser: 'Created by',
        search: 'Search',
        comments: 'Comments',
        yes: 'Yes',
        no: 'No',
        loading: 'Loading...',
        saving: 'Saving...',
        requiredField: 'This field is required',
        requiredOption: 'Select an option',
        na: 'N/A',
        menu1: 'Personnel File',
        menu2: 'Organizational Planning',
        menu3: 'Personnel Movement',
        menu4: 'Disciplinary Procedures',
        menu5: 'Performance Evaluation',
        menu6: 'Health and Wellbeing',
        menu7: 'Assets',
        menu8: 'Payroll',
        menu9: 'Academic Management',
        menu0: 'Official',
        menu10: 'Map',
        menu11: 'Nomina',
    },
    menu: {
        report1: 'Report 1',
        report2: 'Report 2',
        dashboardReport: 'Dashboard Report'
    },
    solicitud: {
        time: 'Response Time',
        title: 'Memorandum of Agreement Request',
        registerRequest: 'Register Request',
        createRequest: 'Create Request',
        updateRequest: 'Update Request',
        requestDetail: 'Request Detail',
        generalInfo: 'General Information',
        processInfo: 'Process Info',
        attachments: 'Attachments',
        tracking: 'Tracking',
        trackingProcess: 'Process Tracking',
        trackingList: 'Tracking List',
        registerComment: 'Register Comment',
        timeline: 'Timeline',
        reviewers: 'Reviewers',
        titleField: 'Title',
        project: 'Project',
        grant: 'Grant',
        amount: 'Amount',
        object: 'Purpose',
        donor: 'Donor',
        responsible: 'Responsible',
        implementingPartner: 'Implementing partner',
        additionalComments: 'Additional Comments',
        requestDate: 'Request Date',
        recordDate: 'Registration Date',
        consecutive: 'Consecutive',
        creatorArea: 'Creator / Area',
        registerCommentBtn: 'Register Comment',
        saveDraft: 'Save draft',
        draftSaved: 'Draft saved successfully',
        requestSaved: 'Request saved successfully',
        commentSaved: 'Comment saved successfully',
        saveError: 'Error saving the request.',
        commentSaveError: 'Error saving the comment.',
        deleteConfirmTitle: 'Confirm deletion',
        deleteConfirmText: 'Are you sure you want to delete this record?',
        editTooltip: 'Edit',
        detailTooltip: 'Detail',
        deleteTooltip: 'Delete',
        approvedRequest: 'Approved request',
        noActionsAvailable: 'You have no actions available for this status.',
        attachAgreement: 'Attach Memorandum of Agreement',
        observations: 'Observations',
        user: 'User',
        from: 'From',
        result: 'Result',
        initialState: 'Initial Status',
        finalState: 'Final Status',
        date: 'Date',
        bp: 'BP',
        unitedId: 'United Nations ID',
        validationDate: 'Validation Date',
        applicationFrom: 'Application From No.',
        agreementNumber: 'Agreement No.',
        policyAttach: 'Attach Policy',
        receiptAttach: 'Attach Payment Receipt',
        maAttach: 'Attach MA',
        fields: {
            searchLabel: 'Search by Title and/or Consecutive'
        },
        validations: {
            draftMin: 'To save a draft, you must enter at least the title and the amount.',
            attachAgreementRequired: 'You must attach the Memorandum of Agreement.',
            actionObservationRequired: 'You must enter observations for this action.',
            bpUnitedDateRequired: 'You must enter BP, United Nations ID, and Validation Date to approve.',
            bpSignetRequired: 'You must assign the request to continue.',
            returnObservationRequired: 'You must enter observations to return.',
            returnFieldsEmpty: 'To return, BP / United Nations ID / Validation Date must be empty.',
            applicationFromRequired: 'You must enter the Application From No.',
            datesRequired: 'You must enter the start date, end date, and memo number.',
            agreementRequired: 'You must enter the Agreement No.',
            stateApprovedNeedBp: 'BP is required when the request is approved',
            stateApprovedNeedUnited: 'United Nations ID is required when the request is approved',
            stateApprovedNeedDate: 'Validation Date is required when the request is approved',
            requiredPolicy: 'Policy is required',
            requiredReceipt: 'Payment receipt is required',
            requiredMA: 'MA is required'
        },
        actions: {
            approve: 'Approve',
            send: 'Send',
            create: 'Create',
            finish: 'Finish',
            liquidate: 'Liquidate',
            return: 'Return',
            reject: 'Reject',
            cancel: 'Cancel'
        },
        results: {
            canceled: 'Canceled',
            request: 'Request',
            received: 'Received',
            comment: 'Comment',
            finished: 'Finished',
            returned: 'Returned',
            code: 'Code'
        },
        excelHeaders: {
            actions: 'Actions',
            status: 'Status',
            consecutive: 'Consecutive',
            title: 'Title',
            requestDate: 'Request Date',
            value: 'Amount',
            grant: 'Grant',
            area: 'Area',
            creatorUser: 'Created by'
        }
    }
}